import * as React from 'react';
const { useState } = React;
const h = React.createElement;

export interface TooltipProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = function Tooltip(props) {
  const { title, children, className = '' } = props;
  const [visible, setVisible] = useState(false);

  return h(
    'div',
    {
      className: `relative inline-block ${className}`,
      onMouseEnter: () => setVisible(true),
      onMouseLeave: () => setVisible(false),
    },
    children,
    visible &&
      h(
        'div',
        {
          className:
            'absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2.5 py-1.5 text-xs text-white bg-dark-900 border border-dark-700 rounded-lg shadow-xl whitespace-nowrap z-50',
        },
        title,
      ),
  );
};

export { Tooltip };
